import { ValidationErrorComponent } from 'components/common-form/sidePanel/status/validationErrors/ValidationErrors.status';
import { OpenInLifecycleButton } from 'components/secondaryMarket/productSearch/modal/buttons';
import { openLifecycleWithUrl } from 'components/secondaryMarket/productSearch/utils';
import { PanelFooter, PanelHeader } from 'components/secondaryMarket/shared/status/Panel';
import type { SecondaryMarketKeys, SecondaryMarketKeysPrefix } from 'locales/secondaryMarketKeys';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import type { SecondaryMarketQuoteRtForm } from 'state/secondaryMarket/realtimeQuote/realtimeQuoteForm';

import type { InitialQuoteSidePanelProps } from './InitialQuote.connect';
import { connectInitialQuoteSidePanel } from './InitialQuote.connect';

const noHiddenFields: readonly [] = [];

const Component: FC<InitialQuoteSidePanelProps> = ({ validationErrors, lifecycleUrl, isReady, onGetQuote }) => {
  const { formatMessage } = useIntl();

  return (
    <div className="d-flex flex-column h-100 overflow-y-auto">
      <PanelHeader textColor="primary" color="light" discreet className="border border-bottom-0" />
      <PanelFooter
        textColor="primary"
        color="light"
        statusKey="secondaryMarket.sidePanel.label.ready"
        icon="offline_bolt"
        discreet
        className="border"
      />
      <div className="w-100 flex-grow-1 overflow-y-auto" id="side-panel-header" data-e2e="side-panel-header">
        <ValidationErrorComponent<SecondaryMarketQuoteRtForm, SecondaryMarketKeys, SecondaryMarketKeysPrefix>
          validationErrors={validationErrors}
          hiddenFields={noHiddenFields}
          onlyErrorsDisplayedInSummary
          errorPrefix="secondaryMarket.form.errors."
          className="mt-3"
        />
      </div>
      <div className="d-flex flex-shrink-0 flex-column">
        <button
          type="button"
          onClick={onGetQuote}
          disabled={!isReady}
          className="btn btn-xl btn-primary m-1"
          data-e2e="btn-get-a-quote"
        >
          {formatMessage({ id: 'secondaryMarket.sidePanel.cta.getQuote' })}
        </button>
        <OpenInLifecycleButton
          className="m-1"
          labelKey="secondaryMarket.modal.buttonOpenInLifecycle"
          onClick={() => openLifecycleWithUrl(lifecycleUrl)}
        />
      </div>
    </div>
  );
};
Component.displayName = 'Component';

export const InitialQuoteSidePanel = connectInitialQuoteSidePanel(Component);
InitialQuoteSidePanel.displayName = 'ConnectedInitialQuoteSidePanel';
